import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map, switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@angular/platform-browser";
import * as i3 from "@ngx-translate/core";
export class TitleService {
    constructor(router, activeRoute, title, translateService) {
        this.router = router;
        this.activeRoute = activeRoute;
        this.title = title;
        this.translateService = translateService;
        this.environment = environment;
        this.default_title = environment.appName;
        this.titles = {};
        this.translateService.get([
            'routeTitles.login',
            'routeTitles.recovery',
            'routeTitles.changePassword',
            'routeTitles.about',
            'routeTitles.beneficiaries',
            'routeTitles.faq',
            'routeTitles.id4',
            'routeTitles.id5',
            'routeTitles.serviceIndex',
            'routeTitles.serviceDetails',
            'routeTitles.serviceAvailability',
            'routeTitles.serviceRequest',
            'routeTitles.contact',
            'routeTitles.feature',
            'routeTitles.sociosanitary',
            'routeTitles.personalArea',
            'routeTitles.personalAreaMyData',
            'routeTitles.personalAreaMyServices',
            'routeTitles.personalAreaMyBeneficiaries',
            'routeTitles.personalAreaRequestDetails',
            'routeTitles.personalAreaStockDetails',
            'routeTitles.vipSearchAirport',
            'routeTitles.vipTerminalDetails',
            'routeTitles.vipResourceDetails',
            'routeTitles.vipCheckAvailability',
            'routeTitles.vipForm',
            'routeTitles.forceError',
            'routeTitles.esimCheckAvailability',
            'routeTitles.esimForm',
            'routeTitles.transferCheckAvailability',
            'routeTitles.transferForm'
        ], {})
            .subscribe(translations => {
            this.titles = translations;
        });
    }
    boot() {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd), map(() => this.activeRoute), map(route => route.firstChild), switchMap(route => route.data), map((data) => {
            return data && data.title && this.titles[data.title] ? `${this.titles[data.title]} • ${this.default_title}` : this.default_title;
        })).subscribe((current_title) => {
            this.title.setTitle(current_title);
        });
    }
    setTitle(title) {
        this.title.setTitle(title + ' • ' + this.default_title);
    }
}
TitleService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TitleService_Factory() { return new TitleService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i1.ActivatedRoute), i0.ɵɵinject(i2.Title), i0.ɵɵinject(i3.TranslateService)); }, token: TitleService, providedIn: "root" });
